var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    width: 13,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5.1,
    fill: "#fff",
    r: 4.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.74c-2.01 0-3.65-1.64-3.65-3.65S4.99 1.44 7 1.44s3.65 1.64 3.65 3.65S9.01 8.74 7 8.74z",
    fill: "#2065B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81 17.73c-.83 0-1.51-.68-1.51-1.51v-.68c0-1 .28-1.98.82-2.82.52-.82 1.25-1.48 2.12-1.91.43-.21.92-.33 1.41-.33.38 0 .75.07 1.11.19.4.14.81.21 1.24.21s.84-.07 1.24-.21c.36-.13.73-.19 1.11-.19.49 0 .98.11 1.41.33.87.43 1.6 1.09 2.12 1.91.54.84.82 1.82.82 2.82v.68c0 .83-.68 1.51-1.51 1.51z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 16.55H1.81c-.18 0-.33-.15-.33-.33v-.68c0-.78.22-1.53.63-2.19.4-.64.97-1.15 1.65-1.48.49-.24 1.07-.27 1.6-.08s1.08.28 1.64.28 1.12-.1 1.64-.28c.53-.19 1.11-.16 1.6.08.67.33 1.24.84 1.65 1.48.41.65.63 1.41.63 2.19v.68c0 .18-.15.33-.33.33z",
    fill: "#2065B5"
  })));
}
export default SvgUserIcon;